import type { WarpDeploymentInfo } from "./types";

interface WarpEnvironment {
  WARP_ARTIFACT_ID?: unknown;
  WARP_ARTIFACT_SHORT_ID?: unknown;
  WARP_ENV_NAME?: unknown;
}

export function collectWarpDeploymentInfo(): WarpDeploymentInfo | undefined {
  if (typeof window === "undefined") return undefined;

  const env = (window as Window & { env?: WarpEnvironment | null }).env;
  const deployment: WarpDeploymentInfo = {};

  if (typeof env?.WARP_ARTIFACT_ID === "string") {
    deployment.artifact_id = env.WARP_ARTIFACT_ID;
  }
  if (typeof env?.WARP_ARTIFACT_SHORT_ID === "string") {
    deployment.artifact_short_id = env.WARP_ARTIFACT_SHORT_ID;
  }
  if (typeof env?.WARP_ENV_NAME === "string") {
    deployment.environment_name = env.WARP_ENV_NAME;
  }

  return Object.keys(deployment).length > 0 ? deployment : undefined;
}
